import React, { lazy } from 'react';

const GLCBAXExportListing = lazy(() =>
  import('./GLCBAXExportListing').then(module => ({
    default: module.GLCBAXExportListing,
  })),
);

const GLCBAXExportForm = lazy(() =>
  import('./GLCBAXExportForm').then(module => ({
    default: module.GLCBAXExportForm,
  })),
);

const glcbAxExportRoutes = [
  {
    props: { exact: true, path: '/gl-interface/gl-cb-export' },
    component: <GLCBAXExportListing />,
  },
  {
    props: { exact: true, path: '/gl-interface/gl-cb-export/add' },
    component: <GLCBAXExportForm mode="add" />,
  },
  {
    props: { exact: true, path: '/gl-interface/gl-cb-export/:exportID/export' },
    component: <GLCBAXExportForm mode="export" />,
  },
  {
    props: { exact: true, path: '/gl-interface/gl-cb-export/:exportID/view' },
    component: <GLCBAXExportForm mode="view" />,
  },
];

export default glcbAxExportRoutes;
